import { type ApiClient, draft } from '../store/backend';
import type { SaveDraftCommand } from '@trinnvis/dabih-api-client';
import { networkState } from '../utilities/network-error-handler';

export async function fetchDraft(
  api: ApiClient,
  entityType: string,
  entityId: string,
  organizationId: number,
): Promise<SaveDraftCommand> {
  // Check if offline before making API call
  if (!networkState.isOnline) {
    throw new Error('Cannot fetch draft while offline');
  }

  return draft(api, entityType, entityId, organizationId);
}
